import { type Scope, createContextScope } from '@radix-ui/react-context'
import { TagIcon } from './components/tag-icon'
import { TagLabel } from './components/tag-label'
import { TagRootVariants } from './tag.styles'
import type { TagContext, TagProps, TagScopedProps } from './tag.types'

export const DISPLAY_NAME = 'Tag'

type TagRootProps = TagProps

const TagRoot = (props: TagRootProps) => {
  const { children, variants, __scopeTag } =
    props as TagScopedProps<TagRootProps>

  return (
    <TagProvider variants={variants} scope={__scopeTag}>
      <div
        data-testid="tag-root"
        className={TagRootVariants({
          variants,
        })}
        style={
          {
            '--color-labeling-fill-onSale-default': '#2A8352',
            '--color-labeling-fill-principal-default': '#303030',
            '--color-labeling-fill-secondary-default': '#E6E6E6',
            '--color-labeling-fill-clubeRaia-default': '#FCE6CF',
            '--color-labeling-fill-clubeDrogasil-default': '#FCE6CF',
            '--color-labeling-fill-assinatura-default': '#F1E9FE',
            '--color-labeling-fill-medicamentoGeladeira-default': '#E6F3FE',
            '--color-labeling-fill-receitaObrigatoria-default': '#E6F3FE',
            '--color-labeling-fill-generico-default': '#FEFAA4',
            '--color-labeling-fill-referencia-default': '#E6E6E6',
            '--color-labeling-fill-similar-default': '#CFE8FC',

            '--color-labeling-text-onSale-default': '#FFF',
            '--color-labeling-text-principal-default': '#F2F2F2',
            '--color-labeling-text-secondary-default': '#424242',
            '--color-labeling-text-clubeRaia-default': '#9F540F',
            '--color-labeling-text-clubeDrogasil-default': '#9F540F',
            '--color-labeling-text-assinatura-default': '#5F28BD',
            '--color-labeling-text-medicamentoGeladeira-default': '#3471A2',
            '--color-labeling-text-receitaObrigatoria-default': '#3471A2',
            '--color-labeling-text-generico-default': '#7A4D0B',
            '--color-labeling-text-referencia-default': '#424242',
            '--color-labeling-text-similar-default': '#204664',
          } as Record<string, string>
        }
      >
        {children}
      </div>
    </TagProvider>
  )
}

const [createTagContext] = createContextScope(DISPLAY_NAME)

export const [TagProvider, useTagContext]: readonly [
  ProviderType<TagContext>,
  (consumerName: string, scope: Scope) => TagContext,
] = createTagContext<TagContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Tag = {
  Root: TagRoot,
  Label: TagLabel,
  Icon: TagIcon,
}
